<template>
  <div>
    {{title}}
  </div>
</template>

<script>

export default {
  name: 'ak-cart-item-display',
  props: {
    id: {
      type: String
    },
    value: {
      type: String
    },
    code: {
      type: String
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      currentValue: null
    }
  },
  mounted() {
    this.currentValue = this.value;
  }
}
</script>
